import { useCallback, useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  KamaButton,
  KamaButtonColors,
  KamaIcon,
} from "@kamatech-ir/kama-react-module";
import { AuthorizedContext } from "layout/authorized/AuthorizedLayout";
import ActiveToken from "./components/ActiveToken";
import styles from "./ProfilePage.module.scss";
import http from "utils/http";
import tools from "utils/tools";

function ProfilePage() {
  const removeConfirmRef = useRef(null);
  const navigate = useNavigate();

  const { activeTokens, fetchActiveTokens } = useContext(AuthorizedContext);

  const [removeBuffer, setRemoveBuffer] = useState<any>();
  const [isRemoveLoading, setIsRemoveLoading] = useState<boolean>(false);

  const handleRemoveClick = (activeToken: any) => {
    setRemoveBuffer(activeToken);
  };
  const removeToken = useCallback(async () => {
    try {
      const { id, clientID, refreshTokenID } = removeBuffer;
      setIsRemoveLoading(true);
      await http.post({
        url: "/api/IssuedToken/RemoveActiveToken",
        data: {
          id,
          clientID,
          refreshTokenID,
        },
      });
      tools.alert.success("نشست مورد نظر با موفقیت غیرفعال شد.");
      setRemoveBuffer(null);
      await fetchActiveTokens();
    } catch (error) {
    } finally {
      setIsRemoveLoading(false);
    }
  }, [removeBuffer, fetchActiveTokens]);

  const currentSession = activeTokens.filter((activeToken) => {
    return activeToken.refreshTokenID === localStorage.refresh_token;
  });
  const otherSessions = activeTokens.filter((activeToken) => {
    return activeToken.id !== currentSession[0]?.id;
  });
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>دستگاه و نشست فعلی</h3>
        <div className={styles.actions}>
          <div
            className={styles.actionButton}
            title="به‌روزرسانی"
            onClick={fetchActiveTokens}
          >
            <KamaIcon icon="refresh" />
          </div>
          <div
            className={styles.actionButton}
            title="بازگشت"
            onClick={() => {
              navigate(-1);
            }}
          >
            <KamaIcon icon="arrow-left-square" />
          </div>
        </div>
      </div>
      <div className={styles.content}>
        {currentSession.length ? (
          <div className={styles.currentSession}>
            <ActiveToken data={currentSession[0]} readonly />
          </div>
        ) : null}

        {otherSessions.length ? (
          <>
            <h3>نشست‌های فعال</h3>
            {otherSessions.map((activeToken, index) => {
              return (
                <ActiveToken
                  key={index}
                  data={activeToken}
                  onRemoveClick={handleRemoveClick}
                />
              );
            })}
          </>
        ) : null}
      </div>

      {removeBuffer ? (
        <div
          className="modalWrapper"
          onClick={(event) => {
            if (event.target === removeConfirmRef.current) {
              setRemoveBuffer(null);
            }
          }}
          ref={removeConfirmRef}
        >
          <div className="modal">
            <div className="modalContent">
              <KamaIcon
                icon="xmark"
                onClick={() => {
                  setRemoveBuffer(null);
                }}
              />
              <div className="modalContext">
                <h4>غیرفعال‌سازی نشست</h4>
                <p>
                  از حذف نشست مربوط به سامانه{" "}
                  <b>{removeBuffer?.clientName ?? "_"}</b> و زمان ورود{" "}
                  <b>
                    {removeBuffer?.issuedDate ? (
                      <>
                        {new Date(removeBuffer?.issuedDate).toLocaleDateString(
                          "fa-IR"
                        )}{" "}
                        |{" "}
                        {new Date(removeBuffer?.issuedDate).toLocaleTimeString(
                          "fa-IR"
                        )}
                      </>
                    ) : (
                      "_"
                    )}
                  </b>{" "}
                  اطمینان دارید؟
                </p>

                <div className="modalButtons">
                  <KamaButton
                    color={KamaButtonColors.CANCEL}
                    onClick={removeToken}
                    disabled={isRemoveLoading}
                  >
                    {isRemoveLoading ? "در حال غیرفعال‌سازی نشست ..." : "تایید"}
                  </KamaButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default ProfilePage;
